import { Fragment } from 'react';
import HandleSectionCondition from './HandleSectionCondition';

type Section = Parameters<typeof HandleSectionCondition>[0]['section'];

type Props = {
  sections: Array<
    & { id: string }
    & Section
  >;
};

const HandleSectionsCondition: React.FC<Props> = ({ sections }) => (
  <Fragment>
    {sections.map((section) => (
      <HandleSectionCondition
        key={section.id}
        section={section}
      />
    ))}
  </Fragment>
);

export default HandleSectionsCondition;